/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import * as lc from '../../../../../utils/lodashCustom';

export function restructureUserOutputAccountsModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    desc: lc.get(data, 'desc'),
    slug: lc.get(data, 'slug'),
    minSumDesc: lc.get(data, 'min_sum_desc'),
    commission: lc.get(data, 'commission'),
    totalCommission: lc.get(data, 'totalCommission'),
    fixedCharge: lc.get(data, 'fixed_charge'),
    rate: lc.get(data, 'rate'),
    commissionDesc: lc.get(data, 'commission_desc'),
    periodDesc: lc.get(data, 'period_desc'),
    placeholder: lc.get(data, 'placeholder'),
    meAccountNumber: _.get(data, 'user_account_data.account_number')
      ? lc.get(data, 'user_account_data.account_number')
      : null,
    bankKey: _.get(data, 'user_account_data.bank_key')
      ? lc.get(data, 'user_account_data.bank_key')
      : null,
    memoTag: _.get(data, 'user_account_data.memo_tag')
      ? lc.get(data, 'user_account_data.memo_tag')
      : null,
    publicDesc: lc.get(data, 'public_desc')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/services/UserOutputAccountsService/restructuring/index.js